import { getAppProfileData } from "global/firestoreData/helpers/appProfileData";
import { useContext, useEffect, useState } from "react";
import { ParentContext } from "../ParentContext";
import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { _currentAppUserCountsCollection } from "global/cnr/reducers/AppUserReducer";
import { AppUserManagementContext } from "../AppUserManagementContext";
import { _showAppLogs, LogContext } from "../LogContext";
import { useAppUserAccess } from "./useAppUserAccess";

const useAppProfileData = ({ allowCurrentUserTracking }) => {

  const parentContext = useContext(ParentContext);
  const { states, handlers, fns } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { eventInfo_handlers } = handlers
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}
  const { appDataDocuments, appProfileData } = eventInfo_state ?? {}
  const { aps_appUserSettings, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserCollections } = aps_appUserSettings ?? {}

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const appUserManagementContext = useContext(AppUserManagementContext);
  const { appUserManagement_handlers } = appUserManagementContext ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  const [currentProfileData, setAppProfileData] = useState()
  const [currentUserCounts, setCurrentUserCounts] = useState()

  const addProfileFlags = (appProfileData) => {

    const { attendees, eventProfiles, clientProfiles } = appProfileData

    if (eventProfiles || clientProfiles) {

      let attendeesWithFlags = [];
      let missingProfileCount = 0;
      let missingEventCount = 0;
      let attendeeCount = 0;

      if (attendees && pathViews.events) {
        const attendeesByEmail = _.keyBy(attendees, 'email');

        attendeesWithFlags = _.mapValues(attendeesByEmail, (attendee, email) => {
          const profile = _.get(eventProfiles, email);

          const hasProfile = !!profile;
          const hasEvent = !!_.get(profile, ['events', pathViews.events]);

          // if (!hasEvent) {
          //   console.log('No Event', profile)
          // }

          attendeeCount++
          if (!hasProfile) missingProfileCount++;
          if (!hasEvent) missingEventCount++;

          return {
            ...attendee,
            _hasProfile: hasProfile,
            _hasEvent: hasEvent
          };
        });
      }

      return {
        attendeeProfiles: attendeesWithFlags,
        counts_attendee: attendees ? {
          attendeeCount,
          missingProfile: missingProfileCount,
          missingEvent: missingEventCount,
        } : null,
        counts_profile: {
          profileCount: _.size(clientProfiles)
        }
      };
    }


    return {}
  };

  useEffect(() => {

    const getData = async () => {

      const cb = async (fetchedData) => {
        setAppProfileData(fetchedData);
        const { attendeeProfiles, counts_attendee, counts_profile } = addProfileFlags(fetchedData)
        fetchedData.attendeeProfiles = attendeeProfiles
        fetchedData.attendeeCounts = counts_attendee
        fetchedData.profileCounts = counts_profile
        eventInfo_handlers.handleSet_appProfileData(fetchedData)
      };

      try {
        if (appProfileData) {
          const { attendeeProfiles, counts_attendee, counts_profile } = addProfileFlags(appProfileData)
          appProfileData.attendeeProfiles = attendeeProfiles
          appProfileData.attendeeCounts = counts_attendee
          appProfileData.profileCounts = counts_profile
          setAppProfileData(appProfileData)
          _showAppLogs.eventInfo && log_handlers.addLog(`♻️👥 Loaded appProfileData from cache (${pathViews.events})`);
          console.log(`♻️👥 Loaded appProfileData from eventInfo`);
        } else {
          const propz = { mainDb, appDataDocuments, appUserCollections, aps_viewItems, pathViews }
          getAppProfileData(propz, cb)
        }

        if (allowCurrentUserTracking) {
          const cbcau = (data) => {
            if (data) {
              setCurrentUserCounts(data)
              appUserManagement_handlers && appUserManagement_handlers.handleSet_currentUserCounts(fetchedData)
            }
          }
          const _refPathCau = createRefPath_event(pathViews, [_currentAppUserCountsCollection])
          database_fns.get_data({ refPath: _refPathCau, callback: cbcau, opts: { ignoreId: true } })
        }

      } catch (err) {
        console.error(`❌ Failed to fetch data-${appUserCollection}:`, err);
      }
    }

    if (isSuperAdmin) {
      getData()
    }

  }, [pathViews.events, appProfileData]);

  return { appProfileData: currentProfileData, currentUsers: currentUserCounts };
};

export default useAppProfileData
